import { render } from "./Modal.vue?vue&type=template&id=eba42ad2&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=eba42ad2&lang=postcss&scoped=true"

import exportComponent from "/Users/johan/dev/litteraturkartan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba42ad2"]])

export default __exports__